import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useSelector } from 'react-redux';
import { resetOrder } from 'actions/orderSearch';
import { setRefunderOrderItems } from 'actions/orderRefund';
import { fetchOrder } from 'actions/orderSearch';
import $S from 'theme/settings';

const $ST = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app.json`);
const $R = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/routes`);

let _content = null;

const OrderRefundDetail = (props) => {
  const { resetOrder, setRefunderOrderItems, fetchOrder, pending } = props;

  const [skuFilter, setSkuFilter] = useState('');
  const [barcodeFilter, setBarcodeFilter] = useState('');
  const [refundInvoiceNumber, setRefundInvoiceNumber] = useState('');
  const [redirect, setRedirect] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState(false);
  const [refundedOrderItems, setRefundedOrderItems] = useState({});
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [isRefundOrderButtonVisible, setIsRefundOrderButtonVisible] =
    useState(false);

  let localRefundOrderNumber = JSON.parse(
    localStorage.getItem('refundOrderNumber')
  );

  const orderData = useSelector((state) => state.orderSearch.order);

  const [order, setOrder] = useState(Object.assign({}, orderData));
  const [orderCopyBarcode, setOrderCopyBarcode] = useState(
    Object.assign({}, orderData)
  );

  useEffect(() => {
    fetchOrder({ order: localRefundOrderNumber }, 'refund');
  }, []);

  const toggleAllCheckbox = (checked) => {
    if (checked) {
      orderData.orderitem_set.forEach((oi) => {
        if (
          !refundedOrderItems[oi.pk] &&
          !(oi.status === '50' || oi.status === '100' || oi.status === '600')
        ) {
          refundedOrderItems[oi.pk] = oi.pk;
        }
      });
    } else {
      orderData.orderitem_set.forEach((oi) => {
        delete refundedOrderItems[oi.pk];
      });
    }
    setRefundedOrderItems(refundedOrderItems);
    setIsAllChecked(checked);
    setIsRefundOrderButtonVisible(checked);
  };

  const refundOrderItem = (order_item, action = true) => {
    if (order_item !== undefined) {
      if (action === true && !refundedOrderItems[order_item.pk]) {
        refundedOrderItems[order_item.pk] = order_item.pk;
      } else {
        delete refundedOrderItems[order_item.pk];
      }
      setRefundedOrderItems(refundedOrderItems);
      const hasObjectKeys = Object.keys(refundedOrderItems).length > 0;
      const isRefundOrderButtonVisible = $S.hasOrderRefundInvoiceNumber
        ? hasObjectKeys && !!refundInvoiceNumber
        : hasObjectKeys;
      setIsRefundOrderButtonVisible(isRefundOrderButtonVisible);
    }
  };

  const refundOrder = () => {
    localStorage.setItem('localRefundOrderData', JSON.stringify(orderData));
    localStorage.setItem(
      'localRefundedOrderItems',
      JSON.stringify(refundedOrderItems)
    );
    localStorage.setItem(
      'localRefundInvoiceNumber',
      JSON.stringify(refundInvoiceNumber)
    );
    setRefunderOrderItems(orderData, refundedOrderItems, refundInvoiceNumber);
    setRedirect(true);
    setRedirectUrl($R.ORDER_REFUND_COMPLETE.path);
  };

  const cleanStateAndRedirect = () => {
    resetOrder();
    setRedirect(true);
  };

  const filterBySku = (val) => {
    let orderState = orderData;
    if (val.trim().length) {
      orderState.orderitem_set = orderState.orderitem_set.filter((oi) => {
        return oi.product.sku === val;
      });
    } else {
      orderState = Object.assign({}, orderData);
    }
    setSkuFilter(val);
    setOrder(orderState);
  };

  const filterByBarcode = (val) => {
    val.persist();
    let orderState =
      Object.keys(orderCopyBarcode).length !== 0 ? orderCopyBarcode : orderData;

    const barcodeKey =
      $ST.BRAND === 'GANT'
        ? 'integration_erenp_erenbarkod'
        : 'integration_barcode';

    setTimeout(() => {
      if (
        (orderState !== undefined && orderState.orderitem_set !== undefined) ||
        orderState.length >= 1
      ) {
        let newOi =
          orderState.orderitem_set !== undefined
            ? orderState.orderitem_set.filter(
                (oi) =>
                  oi.product.attributes[barcodeKey] === val.target.defaultValue
              )
            : orderState.filter(
                (oi) =>
                  oi.product.attributes[barcodeKey] === val.target.defaultValue
              );

        let remainNewOi =
          orderState.orderitem_set !== undefined
            ? orderState.orderitem_set.filter(
                (oi) =>
                  oi.product.attributes[barcodeKey] !== val.target.defaultValue
              )
            : orderState.filter(
                (oi) =>
                  oi.product.attributes[barcodeKey] !== val.target.defaultValue
              );

        if (val.target.defaultValue) {
          setTimeout(() => {
            if (newOi.length > 1) {
              let orderState = orderCopyBarcode;
              setTimeout(() => {
                if (val.target.defaultValue) {
                  let newOi =
                    orderState.orderitem_set !== undefined
                      ? orderState.orderitem_set.filter(
                          (oi) =>
                            oi.product.attributes[barcodeKey] ===
                            val.target.defaultValue
                        )
                      : orderState.filter(
                          (oi) =>
                            oi.product.attributes[barcodeKey] ===
                            val.target.defaultValue
                        );

                  let remainNewOi =
                    orderState.orderitem_set !== undefined
                      ? orderState.orderitem_set.filter(
                          (oi) =>
                            oi.product.attributes[barcodeKey] !==
                            val.target.defaultValue
                        )
                      : orderState.filter(
                          (oi) =>
                            oi.product.attributes[barcodeKey] !==
                            val.target.defaultValue
                        );

                  let multipleFilteredOi = newOi.filter(
                    (item) => item.pk !== newOi[0].pk
                  );

                  setBarcodeFilter(val.target.defaultValue);
                  setOrderCopyBarcode(remainNewOi.concat(multipleFilteredOi));

                  setTimeout(() => {
                    refundOrderItem(newOi[0], true);
                  }, 200);
                }
              }, 300);
            } else {
              refundOrderItem(newOi[0], true);
              setBarcodeFilter(val.target.defaultValue);
              setOrderCopyBarcode(remainNewOi.concat(newOi));
            }
          }, 200);
        }
      }
    }, 200);
  };

  const handleInputChange = (value) => {
    setRefundInvoiceNumber(value);
  };

  return (
    _content &&
    _content({
      props,
      skuFilter,
      barcodeFilter,
      refundInvoiceNumber,
      redirect,
      redirectUrl,
      refundedOrderItems,
      isAllChecked,
      isRefundOrderButtonVisible,
      order,
      pending,
      toggleAllCheckbox,
      refundOrderItem,
      refundOrder,
      cleanStateAndRedirect,
      filterBySku,
      filterByBarcode,
      handleInputChange,
    })
  );
};

const mapDispatchToProps = {
  setRefunderOrderItems,
  fetchOrder,
  resetOrder,
};

const mapStateToProps = (state) => ({
  order: state.orderSearch.order,
  pending: state.orderSearch.pending,
});

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(OrderRefundDetail);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/orders/refund/orderRefundDetail/index.js